<template>

  <div :class="{ hide: !isVisible() }" class="track-info-panel">
    <div v-if="info">
      <button class="button-large" @click="closeInfo()">Close</button>
      <div class="info" v-if="info.item && info.item.id">
        <h2 v-text="$v(info, 'item.title')"></h2>
        <p><b>Artist:</b> <span v-text="$v(info, 'item.artist')"></span></p>
        <!-- <p v-text="info.item.album"></p> -->
        <p><b>Year:</b> <span v-text="$v(info, 'item.year')"></span></p>
        <p><b>Path:</b> <span v-text="$v(info, 'item.path')"></span></p>
        <!-- <p><b>Crossfade:</b> <span v-text="info.item.crossfade_start || 'None'"></span> - <span v-text="formatTime(info.item.crossfade_end) || 'None'"></span> (<span v-text="formatTime(info.timelineDuration)"></span> total)</p> -->
        <p>
          <b>Crossfade:</b> 
            Start: <span v-text="info.item.crossfade_start + 's' || 'None'"></span> 
          | End: <span v-text="info.item.crossfade_end + 's' || 'None'"></span> 
          <br>
          (<span v-text="formatTime(info.item.crossfade_start, true) || 'None'"></span> - <span v-text="formatTime(info.item.crossfade_end) || 'None'"></span>) 
          [<span v-text="formatTime(info.timelineDuration)"></span> without crossfades]
        </p>
      </div>
      <div class="info">
        <h4>Meta</h4> <pre class="code" v-text="info.meta || 'None'"></pre>
        <h4>Command</h4> <pre class="code" v-text="info.command || 'None'"></pre>
        <!-- <p>Track Meta: <span v-text="info.meta"></span></p> -->
        <!-- <p>Playlist order: <span v-text="info.track.order"></span></p> -->
      </div>
      <h3>Played:</h3>
      <p v-if="isLoading" class="loading-text">Loading...</p>
      <div v-if="!isLoading" class="box-with-scrollbar">
        <!--
        <ul>
          <li v-if="info.item && info.item.actions" v-for="action in info.item.actions">
            <div v-text="$moment(action.started_at).format('YYYY-MM-DD HH:mm:ss')"></div>
          </li>
        </ul>
        -->
        <p v-if="!info.item || !info.item.actions || info.item.actions.length == 0">(None)</p>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'track-info',
  props: ['info', 'is-loading'],
  data() {
    return {
      UI: {
        isInfoLoading: false
      }
    }
  },
  methods: {

    isVisible(){
      return this.info && this.info.track
    },

    formatTime(seconds, includeMS) {
      // console.log(seconds)

      if (!seconds || typeof seconds === 'undefined') {
        return '';
      }

      // TODO: Include option for milliseconds.

      const date = new Date(null);
      date.setSeconds(seconds);
      const time = date.toISOString().substr(11, 8);
      let timeTrimmed = time;
      let trimLimit = 0;

      // Remove leading zeroes
      while ((timeTrimmed.substr(0, 1) === '0' || timeTrimmed.substr(0, 1) === ':') && trimLimit <= 3) {
        timeTrimmed = timeTrimmed.slice(1);
        trimLimit += 1;
      }

      return timeTrimmed;
    },
    
    update() {
      
      const parentThis = this;

      console.log("Opening info.")
      console.log(track)

      this.UI.isLoading = false

      // If track has an item, then get its past actions.
      if(track.item){
        this.UI.isLoading = true
        $axios
          .get(`${this.config.address}/items/${track.item.id}?i=${parentThis.instance.name}`)
          .then((response) => {
            console.log(response.data.data)
            if(response.data && response.data.data){
              parentThis.info.item = response.data.data
            }
            this.UI.isLoading = false
          })
          .catch((error) => {
            this.UI.isLoading = false
          });
      }

    },

  },
  mounted() {

  },
};
</script>

